var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.579,
    height: 14.2,
    viewBox: "0 0 18.579 14.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19174",
    "data-name": "Path 19174",
    d: "M16.764,61H1.615A1.618,1.618,0,0,0,0,62.615V73.385A1.618,1.618,0,0,0,1.615,75H16.764a1.618,1.618,0,0,0,1.615-1.615V62.615A1.618,1.618,0,0,0,16.764,61Zm-.223,1.077L9.224,69.394l-7.38-7.317ZM1.077,73.162V62.833l5.186,5.142Zm.761.761,5.19-5.19,1.818,1.8a.538.538,0,0,0,.76,0l1.773-1.773,5.162,5.162ZM17.3,73.162,12.141,68,17.3,62.838Z",
    transform: "translate(0.1 -60.9)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBig);
export default __webpack_public_path__ + "static/media/mail_big.afd7b0a12d6c9178a6a50575aff502f2.svg";
export { ForwardRef as ReactComponent };